import styled from 'styled-components';
export const IndicatorCricle = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  border: 1px solid transparent;
  display: inline-block;
`;
export const IndicatorTitle = styled.span`
  padding: 5px;
`;
export default {
  IndicatorCricle,
  IndicatorTitle
};